export default __webpack_public_path__ + "static/media/manali1.8ef272af.webp";